module.exports = __webpack_public_path__ + "static/media/front-selected.93ec4729.svg";